import { FunctionComponent, ComponentType } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPageLocalized from './ErrorPageLocalized';

import { log } from '../helpers';

export const RFIsErrorBoundary: FunctionComponent = ({ children }) => (
  <ErrorBoundary FallbackComponent={ErrorPageLocalized} onError={log.error}>
    {children}
  </ErrorBoundary>
);

export const withRFIsErrorBoundary = (ComponentThatMayError: ComponentType) => {
  const Wrapped: ComponentType = (props) => (
    <RFIsErrorBoundary>
      <ComponentThatMayError {...props} />
    </RFIsErrorBoundary>
  );

  // Format for display in DevTools
  const name = ComponentThatMayError.displayName || ComponentThatMayError.name || 'Unknown';
  Wrapped.displayName = `withRFIsErrorBoundary(${name})`;

  return Wrapped;
};
